<template>
	<div id="testModule">
		<Test :id="parseInt(id)" :env="env" />

		<!-- {{ env }} -->
	</div>
</template>

<script>
import Test from "./components/Test";

export default {
	components: {
		Test
	},
	
	props: ['id'], // bere se z atributu data-id="" u root elementu, který je nastavený pro mountování Vuečka

	data() {
		return {
			env: process.env
		}
	},
};
</script>
